import { useIntl } from 'react-intl';
import { useCallback } from 'react';

import { useConfiguration } from '@ocx/data-configuration';
import { PurchaseIneligibilityReason } from '@ocx/data-offers';
// eslint-disable-next-line @nx/enforce-module-boundaries -- app snackbar
import { useSnackbar } from '@ocx-app/lib/snackbar/snackbar';

import { getIneligibilityMessageDescriptor } from './ineligibility.messages';

export const useShowExplanationSnackbarForIneligibleOffer = () => {
  const intl = useIntl();
  const snackbar = useSnackbar();
  const pointsStrategy = useConfiguration('loyaltyProgram.pointsStrategy');

  return useCallback(
    (reason: PurchaseIneligibilityReason) => {
      snackbar.open(intl.formatMessage(getIneligibilityMessageDescriptor(reason, pointsStrategy)));
    },
    [intl, pointsStrategy, snackbar],
  );
};
